export default "__VITE_ASSET__BPhBtMEY__"